import { useEffect, useState } from "react";

export function useTopicsFetch(search) {
    const [topics, setTopics] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const apiUrl = `https://692572e382b59600d723ac24.mockapi.io/webTopics/courses?search=${search}`;
        // Fetch user data based on userId
        const fetchData = async () => {
            try {
                // Set loading to true when fetching data
                setLoading(true);
                const response = await fetch(apiUrl);
                const courses = await response.json();
                setTopics(Array.isArray(courses) ? courses : []);
            } catch (error) {
                console.error(
                    "Something went wrong. Web topics failed to load.",
                    error
                );
                setError(error);
            } finally {
                // Set loading to false after fetching data
                setLoading(false);
            }
        };

        const debounce = setTimeout(fetchData, 300);
        return () => clearTimeout(debounce);
    }, [search]);

    return { topics, loading, error };
}